angular.module('zc.master.zcliteProjectsForReview', [
  'zc.master'
])



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_projects_for_review/index.coffee